"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactInstantsearchDom = require("react-instantsearch-dom");
var _generic = _interopRequireDefault(require("../icons/generic"));
var _algoliaSearchbox = _interopRequireDefault(require("./algolia-searchbox"));
var _searchNavItems = _interopRequireDefault(require("./search-nav-items"));
var _articleProgressBar = _interopRequireDefault(require("./article-progress-bar"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Components

// Utils

// Styles
const {
  below
} = (0, _utils.getMediaQueries)();
const SearchNavStyles = (0, _styledComponents.createGlobalStyle)([".ais-SearchBox{margin-bottom:32px;background:var(--ice-grey-1-hex);display:flex;align-items:center;justify-content:center;}.ais-SearchBox-form{padding:13px 0px 15px;transition:0.3s ease-in-out;&:focus-within{padding:96px 0px;transition:0.3s ease-in-out;}}.ais-SearchBox-input{padding:0;width:440px;border-radius:0px;outline:none;border:none;border-bottom:0.5px solid var(--dusky-grey-6-hex);background:var(--ice-grey-1-hex);font-family:\"Playfair Display\";transition:0.3s ease-in-out;font-size:28px;line-height:36px;&:focus{border-bottom:2px solid #0b7df4;", "}}.ais-SearchBox-submit{background:none;color:inherit;border:none;padding:0;font:inherit;cursor:pointer;}.ais-SearchBox-reset{display:none;}"], below.mobile`
    border-bottom: 1px solid #0b7df4;
    `);
const CategorySearchBoxWrapper = _styledComponents.default.div.withConfig({
  displayName: "search-nav__CategorySearchBoxWrapper",
  componentId: "sc-xpxb3k-0"
})(["background:var(--ice-grey-1-hex);position:relative;"]);
const CategorySearchBoxContainer = _styledComponents.default.div.withConfig({
  displayName: "search-nav__CategorySearchBoxContainer",
  componentId: "sc-xpxb3k-1"
})(["max-width:1248px;padding:0 24px;margin:0 auto;display:flex;flex-direction:", ";justify-content:space-between;@media (min-width:600px){padding:0 48px;}"], props => props.searchBoxFocus ? "column" : "row");
const ActivateSearchButton = _styledComponents.default.button.withConfig({
  displayName: "search-nav__ActivateSearchButton",
  componentId: "sc-xpxb3k-2"
})(["align-self:center;background:none;color:inherit;border:none;height:fit-content;padding:0;font:inherit;cursor:pointer;outline:inherit;display:", ";@media (min-width:950px){display:none;}"], props => props.searchBoxFocus ? "none" : "flex");

// Main Component
const SearchNav = ({
  categoryBadgeColor,
  categoryBadgeHoverColor,
  articleSlug,
  articleCategory,
  navItems,
  navIsOpen,
  suggestedSearchButtons,
  articleProgressBarContainer,
  articleProgressBarRoot,
  searchBoxFocus,
  setSearchBoxFocus
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !navIsOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SearchNavStyles, {
    articleSlug: articleSlug
  }), /*#__PURE__*/_react.default.createElement(_reactInstantsearchDom.ScrollTo, null, /*#__PURE__*/_react.default.createElement(CategorySearchBoxWrapper, {
    className: "search-nav-items"
  }, /*#__PURE__*/_react.default.createElement(CategorySearchBoxContainer, {
    searchBoxFocus: searchBoxFocus
  }, /*#__PURE__*/_react.default.createElement(_searchNavItems.default, {
    searchBoxFocus: searchBoxFocus,
    setSearchBoxFocus: setSearchBoxFocus,
    categoryBadgeColor: categoryBadgeColor,
    categoryBadgeHoverColor: categoryBadgeHoverColor,
    articleSlug: articleSlug,
    navItems: navItems
  }), /*#__PURE__*/_react.default.createElement(_algoliaSearchbox.default, {
    searchBoxFocus: searchBoxFocus,
    setSearchBoxFocus: setSearchBoxFocus,
    suggestedSearchButtons: suggestedSearchButtons
  }), /*#__PURE__*/_react.default.createElement(ActivateSearchButton, {
    searchBoxFocus: searchBoxFocus,
    onClick: () => setSearchBoxFocus(true)
  }, /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "search",
    color: _utils.colors["dusky-grey-6"].hex
  })))), articleSlug && !searchBoxFocus && /*#__PURE__*/_react.default.createElement(_articleProgressBar.default, {
    categoryBadgeColor: categoryBadgeColor,
    categoryBadgeHoverColor: categoryBadgeHoverColor,
    articleCategory: articleCategory,
    articleProgressBarRoot: articleProgressBarRoot,
    articleProgressBarContainer: articleProgressBarContainer
  }))));
};
SearchNav.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchNav"
};
var _default = SearchNav;
exports.default = _default;